import { size, orderBy } from "lodash";
import store from "stores";
import { userType } from "const/nuclias/user";
import orgService from "services/Auth.Organization.service";
import { iconType } from "../Headers/const";

const initTargetOrg = () => {
  const pageContext = store.getState().pageContext;
  const user = store.getState().user.user;
  const editObj = {};
  if (pageContext.selectedOrg) {
    editObj.icon = iconType.org;
    editObj.name = pageContext.selectedOrg.name;
    editObj.id = pageContext.selectedOrg.id;
  } else {
    if (user.type === userType.si) {
      editObj.icon = iconType.msp;
      editObj.name = pageContext.si.name;
      editObj.id = pageContext.si.id;
    } else if (user.type === userType.sp) {
      editObj.icon = iconType.msp;
      editObj.name = pageContext.sp.name;
      editObj.id = pageContext.sp.id;
    } else {
      console.error('initTargetOrg error');
    }
  }

  return editObj;
};

const searchOrgOption = async (param) => {
  let skip = 0;
  if (param.data.length > 0 && param.search.total > param.data.length) {
    skip = Math.trunc(param.data.length / 10) * 10;
  }
  const ds = store.getState().pageContext.si || store.getState().pageContext.sp;
  const params = {
    name: size(param.search.name) > 0 ? param.search.name : '%',
    skip,
    limit: 10
  };
  const res = await orgService.searchIndexOrg(ds.id, params);

  param.search.total = res.total;
  const resultData = skip > 0 ? param.data.concat(res.data) : res.data;

  let result = {
    search: param.search,
    data: orderBy(resultData, [item => item.name.toLowerCase()], 'asc'),
  };

  return result;
};

export default {
  initTargetOrg,
  searchOrgOption,
};